var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main-modal',{on:{"closeModal":function($event){return _vm.$emit('closeModal')}}},[[_c('video',{attrs:{"width":"1300","height":"800","src":_vm.url,"controls":""}})]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }